import moment from "moment";

export const BREAKUP_LABELS = {
  gym_new: "Gym New",
  gym_renew: "Gym Existing / Renew",
  pt_new: "Personal Training New",
  pt_renew: "Personal Training Renew",
  gx: "GX Studio",
  nutrition: "Nutrition",
  physio: "Physio",
  academy: "Academy",
  cafe: "Café",
  other: "Other",
};

export const money = (v) =>
  `Rs ${Number(v ?? 0).toLocaleString("en-PK", { maximumFractionDigits: 0 })}`;

export const moneyDec = (v) =>
  Number(v ?? 0).toLocaleString("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const num = (v) => Number(v ?? 0).toLocaleString("en-PK");

export const branchTitle = (label) =>
  `VOSTRO WORLD (${String(label || "ALL BRANCHES").toUpperCase()}) — DAILY MIS REPORT`;

export const formatReportDate = (iso) =>
  moment(iso).format("dddd, DD MMMM YYYY");
